export const getters = {
  getActiveTabIndex: (state, id) => state.activeTabState[id],
};
